import { zodResolver } from '@hookform/resolvers/zod';
import { Turnstile } from '@marsidev/react-turnstile';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router';
import { z } from 'zod';
import RHFInput from './RHF/RHFInput';
import { RHFSubmitButton } from './RHF/RHFSubmitButton';
import type { ForgotPasswordViewModel } from '../models/AccountViewModels/ForgotPasswordViewModel';
import AuthApi from '../apis/AuthApi';
import { handleError } from '../apis';
import { toast } from 'react-toastify';

const forgotPasswordSchema = z.object({
  email: z.email('Required!').trim(),
});

export type ForgotPasswordSchema = z.infer<typeof forgotPasswordSchema>;

export default function ForgotPasswordForm() {
  const [status, setStatus] = useState<string>('');
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm<ForgotPasswordSchema>({
    resolver: zodResolver(forgotPasswordSchema),
  });

  const handleForgotPassword = async (values: ForgotPasswordSchema) => {
    if (status === '') {
      toast.error('Please complete the CAPTCHA');
      return;
    }
    const submitValues = {
      ...values,
      cfTurnstileResponse: status,
    } as ForgotPasswordViewModel;

    try {
      const response = await AuthApi.forgotPassword(submitValues);
      if (response.message === 'Check Email') {
        setIsSuccess(true);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      const message = await handleError(error);
      toast.error(message);
    }
  };
  return (
    <div
      className='my-4 flex w-[320px] flex-initial flex-col items-center justify-start self-auto rounded-2xl border border-gray-500 p-3 dark:border-gray-500 '
      id='forgot-form'
    >
      {isSuccess ? (
        <>
          <h3>Check Your Email</h3>
          <p>A Confirmation email has been sent</p>
          <p className='text-sm text-amber-500 dark:text-amber-200'>
            (Not there? Check the spam folder)
          </p>
        </>
      ) : (
        <>
          <h3 className='mb-2'>Forgot Password</h3>
          <form onSubmit={handleSubmit(handleForgotPassword)}>
            <RHFInput
              name='email'
              label='Email'
              type='text'
              register={register('email')}
              errors={errors}
            />
            <div id='cf-turnstile' className='flex items-center justify-center'>
              <Turnstile
                siteKey='0x4AAAAAAA3HFdGjg5hs9TLl'
                onError={() => setStatus('')}
                onExpire={() => setStatus('')}
                onSuccess={(token) => setStatus(token)}
              />
            </div>
            {status !== '' && <RHFSubmitButton isSubmitting={isSubmitting} />}
          </form>

          <Link to='/' className='text-xs'>
            or Login
          </Link>
        </>
      )}
    </div>
  );
}
